import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useTranslation } from 'next-i18next'
import { SpaceFullAddress } from '~/domains/spaces/components/atoms/space-full-address'
import { TransportationAccess } from '~/domains/spaces/components/molecules/transportation-access'
import { SpaceSectionContent } from '~/domains/spaces/components/space-details/space-section-content'
import { useSpaceAddress } from '~/domains/spaces/hooks/use-space-address.hook'
import { SpaceSectionTitle } from './space-section-title'

export const SpaceLocalisation = ({ space }: { space: Space }) => {
	const { t } = useTranslation()
	const { fullAddress } = useSpaceAddress(space, true)

	return (
		<SpaceSectionContent id='location'>
			<SpaceSectionTitle>
				{t('space:sections.location.title.long')}
			</SpaceSectionTitle>

			<div className='grid grid-cols-1 gap-8 lg:grid-cols-2'>
				<div className='flex flex-col gap-4'>
					{t('space:sections.location.body')}

					<SpaceFullAddress
						as='a'
						href={`https://www.google.com/maps/search/?api=1&query=${fullAddress}`}
						target='_blank'
						space={space}
						showIcon={false}
						className='whitespace-normal text-sm'
					/>
				</div>

				<TransportationAccess space={space} />
			</div>
		</SpaceSectionContent>
	)
}
